window.setupSwatchHoverEffect = function () {
  if(document.querySelectorAll(".swatch-img-item").length > 0){
    document.querySelectorAll(".swatch-img-item").forEach(el => {
      if(el.querySelector("img")){
          el.querySelector("img").addEventListener("mouseenter", function(e){
              document.querySelectorAll(".swatch-img-item").forEach(item => {
                item.classList.remove('active');
              });
              e.currentTarget.closest(".swatch-img-item").classList.add('active');
              e.currentTarget.closest("li").classList.add('swatch-active');
              e.currentTarget.closest("li").querySelector("div[data-scale-reveal]").innerHTML =  window.variantDetails[`${ e.currentTarget.dataset.productId }-${ e.currentTarget.dataset.variantId }`].featured_image
              e.currentTarget.closest("li").querySelector(".text-theme-basic").outerHTML = window.variantDetails[`${ e.currentTarget.dataset.productId }-${ e.currentTarget.dataset.variantId }`].price;
          });
      } 
      
    });
    
    document.querySelectorAll(".swatch-img-list").forEach(item => {
      item.addEventListener("mouseleave", function(e){
          console.log('tttttt');
          document.querySelectorAll("#facets-results li").forEach(el => {
            el.classList.remove('swatch-active');
          });
          document.querySelectorAll(".swatch-img-item").forEach(item => {
            item.classList.remove('active');
          });  
      });  
    });
  }
}

window.setupSwatchHoverEffect();